import { GLBModel } from "@/scene/GLBModel";
import type { EnvironmentDecorItemConfig } from "@/scene/SceneProps";
import {
  LOG_MODEL,
  ROCK_FORMAT2_MODEL,
  ROCK_MODEL,
  WAGON_WHEEL_MODEL,
} from "./shared";
import { UnderwaterVisualSettingsOverride } from "@/scene/VisualSettings";

// Белуга (#3) — Химический (нефть): канистра, нефть
export const BELUGA_GARBAGE_MODELS = [
  new GLBModel("/models/garbage/canister.glb"),
  new GLBModel("/models/garbage/Oil.glb"),
];

export const BELUGA_ENVIRONMENT_DECOR: EnvironmentDecorItemConfig[] = [
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 0.78,
    position: { x: -4.6, y: -3.15, z: 1.4 },
    rotation: { x: 0, y: -0.889, z: 0 },
    scale: { x: 2.5, y: 3.2, z: 3.65 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.58,
    position: { x: 1.65, y: -2.28, z: -0.9 },
    rotation: { x: 0, y: -0.7, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 0.52,
    position: { x: -1.65, y: -2.29, z: -5.3 },
    rotation: { x: 0, y: 2.35, z: 0 },
    scale: { x: 1.7, y: 4.1, z: 3.4 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.44,
    position: { x: -1.05, y: -2.3, z: 1.02 },
    rotation: { x: 0, y: 1.65, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: LOG_MODEL,
    targetSize: 1.35,
    position: { x: -0.5, y: -2.28, z: 1.9 },
    rotation: { x: 0.035, y: -0.606, z: 0.052 },
    scale: { x: 2.1, y: 3.15, z: 1.3 },
  },
  {
    model: LOG_MODEL,
    targetSize: 2,
    position: { x: -3.3, y: -2.26, z: -1 },
    rotation: { x: 0, y: -0.873, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: LOG_MODEL,
    targetSize: 2,
    position: { x: -2.35, y: -3.05, z: 3 },
    rotation: { x: 3.142, y: -0.961, z: 3.142 },
    scale: { x: 4.5, y: 6, z: 1 },
  },
  {
    model: LOG_MODEL,
    targetSize: 2,
    position: { x: 3, y: -2, z: 0.36 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 1.07,
    position: { x: 2, y: -2.27, z: 2 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.7,
    position: { x: -3.55, y: -3, z: -4.45 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 2.65, y: 3.25, z: 1.85 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.7,
    position: { x: -2.55, y: -2.8, z: 1.55 },
    rotation: { x: 0, y: 0.611, z: 0 },
    scale: { x: 2, y: 2.1, z: 1.35 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.7,
    position: { x: 0, y: -2.28, z: -4.25 },
    rotation: { x: 0, y: 1.047, z: 0 },
    scale: { x: 1.8, y: 2.85, z: 1.6 },
  },
  {
    model: WAGON_WHEEL_MODEL,
    targetSize: 0.7,
    position: { x: -1.45, y: -2.4, z: -3.3 },
    rotation: { x: -0.609, y: 0.661, z: 0.35 },
    scale: { x: 3.25, y: 3.25, z: 1 },
  },
];


export const BELUGA_VISUAL_SETTINGS: UnderwaterVisualSettingsOverride = {
  waterSurfaceColor: "#2d8fa3",
  pollutionColor: "#324c72",
};
